import request from '../utils/request';

/**
 * Created : vincent
 * Date : 2018/5/13  5:20 PM
 * Email : wangxiao@wafersystems.com
 */
/**
 * 故障展板TOP5
 * @param token
 * @param locale
 * @returns {Object}
 */
export const findFaultTops = ({ token, days, locale }) => {
  const url = `/monitor/findFaultTops?token=${token}&days=${days}&lang=${locale}`;
  return request(url);
};

/**
 * 故障展板charts
 * @param token
 * @param days
 * @param locale
 * @returns {Object}
 */
export const findFaultCharts = ({ token, days, locale }) => {
  const url = `/monitor/findFaultCharts?token=${token}&days=${days}&lang=${locale}`;
  return request(url);
};

/**
 *故障数 故障率统计
 * @param token
 * @param locale
 * @returns {Object}
 */
export const findFaultNum = ({ token, locale }) => {
  const url = `/monitor/findFaultNum?token=${token}&lang=${locale}`;
  return request(url);
};

/**
 * 故障展板列表
 * @param token
 * @param startTime
 * @param endTime
 * @param roomIds
 * @param locale
 * @returns {Object}
 */
export const findBoardFaultList = ({
  token,
  startTime,
  endTime,
  roomIds,
  locale
}) => {
  const url = `/monitor/findFaultBoardList?token=${token}&startTime=${startTime}&endTime=${endTime}&roomIds=${roomIds}&lang=${locale}`;
  return request(url);
};



// WEBPACK FOOTER //
// ./src/services/fault.js